import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';

/**
 * Extraction-check mismatches for a v3 draft sales order (spec §5): an
 * independent second pass surfacing discrepancies (totals reconciliation, …).
 */
export function useDraftMismatches(draftSalesOrderId: string | undefined) {
  const query = useQuery({
    ...orpc.accountsReceivable.draftSalesOrders.getMismatches.queryOptions({
      input: { draftSalesOrderId: draftSalesOrderId ?? '' },
    }),
    enabled: !!draftSalesOrderId,
  });
  return { ...query, mismatches: query.data?.mismatches };
}

/** Resolve a mismatch (dismiss / add / pending / reopen); persists + audits. */
export function useResolveDraftMismatch(draftSalesOrderId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: rpcClient.accountsReceivable.draftSalesOrders.resolveMismatch,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey:
          orpc.accountsReceivable.draftSalesOrders.getMismatches.queryKey({
            input: { draftSalesOrderId },
          }),
      });
    },
  });
}
